// ========== options ==========
// minDate <date> optional
// maxDate <date> optional
// disableWeekends <boolean> defaults false
// onSelect <function> optional - fires when a date is selected - receives a date parameter
// onClose <function> optional - fires on close
// onOpen <function> optional - fires on open
// onDraw <function> optional - fires every time it builds a calendar... ex: open and month change. - receives an array of objects with date and element

/*********************************
 * requires jsscripts/libraries/pickaday/pickaday.min.js to be on the page.
 **********************************/

export function DatePicker(input, options) {
    if (!input || input.nodeType !== 1) {
        throw new Error('DatePicker requires an input element to be passed into it.');
    }

    var inputValue = input.value;

    this._options = extend({}, DatePicker._defaults, options, {
        field: input,
        onDraw: this._onDraw(options),
        onOpen: () => this._correctPositionWhenModalOpen()
    });

    this._picker = new window.Pikaday(this._options);

    this.element = this._picker.el;

    if (!inputValue) {
        input.value = inputValue;
    }
}

DatePicker._defaults = {
    format: 'mm/dd/yy',
    toString: function (date) {
        var day = zeroPad(date.getDate()),
            month = zeroPad(date.getMonth() + 1),
            year = date.getFullYear();

        return month + '/' + day + '/' + year;
    },
    minDate: new Date()
};

DatePicker.prototype._correctPositionWhenModalOpen = function () {
    const $openModal = document.querySelector('.dialog.is-open');
    const currentBodyTop = parseInt(document.body.style.top);

    if (!$openModal || isNaN(currentBodyTop)) {
        return;
    }

    this.element.style.top = `${Math.abs(currentBodyTop) + parseInt(this.element.style.top)}px`;
};

DatePicker.prototype._onDraw = function (options) {
    return function (pikadayInstance) {
        if (options && typeof options.onDraw === 'function') {
            var calendarDate = getCalendarDate(
                pikadayInstance.calendars[0].month + 1,
                pikadayInstance.calendars[0].year
            );
            options.onDraw(
                this,
                [].slice
                    .call(pikadayInstance.el.querySelectorAll('[data-day]:not(.is-disabled)'))
                    .map(function (element) {
                        return {
                            element: element,
                            date: calendarDate(element.dataset.day)
                        };
                    })
            );
        }
    }.bind(this);
};

DatePicker.prototype.show = function () {
    this._picker.show();
};

DatePicker.prototype.hide = function () {
    this._picker.hide();
};

DatePicker.prototype.destroy = function () {
    this._picker.destroy();
};

DatePicker.prototype.setDate = function (date) {
    this._picker.setDate(date);
};

DatePicker.prototype.setMessage = function (content) {
    var container = this.element.querySelector('.pika-lendar'),
        message,
        div;

    if (container) {
        message = this.element.querySelector('.sp-datepicker-message');

        if (!message) {
            div = document.createElement('div');
            div.className = 'sp-datepicker-message';
            this.element.appendChild(div);
            message = div;
        }

        div = document.createElement('div');
        div.innerHTML = content;
        message.appendChild(div);
    }
};

export function datepicker(content, options) {
    return new DatePicker(content, options);
}

function extend(target) {
    var to = Object(target),
        i = 1,
        l = arguments.length,
        source,
        n;

    for (; i < l; i++) {
        source = arguments[i];
        if (source !== null) {
            for (n in source) {
                if (Object.prototype.hasOwnProperty.call(source, n)) {
                    to[n] = source[n];
                }
            }
        }
    }

    return to;
}

function getCalendarDate(month, year) {
    return function (day) {
        return new Date(month + '/' + day + '/' + year);
    };
}

function zeroPad(n) {
    var num = parseInt(n);
    return num < 10 ? '0' + num : num;
}
